import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetRoles } from '../../hooks/react-query/useUserRoles';
import { LeftArrow, UserList } from '../../icons';
import { Rounded } from '../../components/elements/rounded';
import { PageTitle } from '../../components/ui';
import { ListSkeletion } from '../../components/elements/skeletions/skeletions';
import Container from '../../components/elements/container';

const UserRoles = () => {
  const navigate = useNavigate();

  const { data: userData, isLoading } = useGetRoles();

  if (isLoading) {
    return (
      <section className="container mx-auto py-10 flex flex-col gap-6">
        <div className="grid lg:grid-cols-2 gap-3">
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
          <ListSkeletion />
        </div>
      </section>
    );
  }

  return (
    <Container className="flex flex-col gap-6">
      <PageTitle
        title={
          <div className="flex lg:p-2 max-lg:gap-x-6 items-center">
            <button className='lg:p-2' onClick={() => navigate('/dashboard')}>
              <LeftArrow width={32} height={32} />
            </button>
            <h2>Roles</h2>
          </div>
        }
        wrapperClassName="justify-between"
        displaySearch={false}
      />
      <ul className="grid lg:grid-cols-2 gap-3">
        {userData.data.map(({ id, name }) => {
          return (
            <li
              key={id}
              className="flex bg-white justify-between py-3 px-6 rounded-lg"
            >
              <div className="flex gap-3 items-center">
                <Rounded className="bg-powdergrey p-3">
                  <UserList />
                </Rounded>
                <span>{name}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </Container>
  );
};

export default UserRoles;
